import './LandCompanyDrawer.css'
import 'antd/dist/reset.css'
import React from 'react'
import { ConfigProvider, Drawer, Menu } from 'antd'

export const companyDrawerHeight = 250

export default class LandCompanyDrawer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  render() {
    return (
      <Drawer
        height={companyDrawerHeight}
        title={null}
        placement="top"
        closeIcon={null}
        open={this.props.open}
        rootStyle={{ position: 'fixed', top: '10vh', zIndex: 100 }}
        styles={{
          header: {
            paddingLeft: '8vw',
            paddingRight: '8vw',
            paddingTop: '0px',
            paddingBottom: '0px',
          },
          body: {
            paddingLeft: '8vw',
            paddingRight: '8vw',
            paddingTop: '0px',
            paddingBottom: '0px',
          },
        }}
      >
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                itemHeight: 50,
                itemMarginInline: 0,
              },
            },
          }}
        >
          <Menu
            items={[
              {
                key: 'company',
                label: (
                  <div
                    className="LandCompanyName"
                    onClick={() => {
                      this.props.handleClose()
                      this.viewCompanyInfo()
                    }}
                  >
                    公司介绍
                  </div>
                ),
              },
              {
                key: 'certificates',
                label: (
                  <div
                    className="LandCompanyName"
                    onClick={() => {
                      this.props.handleClose()
                      this.viewCertificates()
                    }}
                  >
                    资质证书
                  </div>
                ),
              },
              {
                key: 'document',
                label: (
                  <div
                    className="LandCompanyName"
                    onClick={() =>
                      this.downloadFile(
                        'https://www.keystridevalve.com/files/%E7%AE%A1%E4%BB%B6%E4%B8%8E%E9%98%80%E9%97%A8.pdf'
                      )
                    }
                  >
                    产品文档（管件与阀门）
                  </div>
                ),
              },
              {
                key: 'contact',
                label: (
                  <div
                    className="LandCompanyName"
                    onClick={() => {
                      this.props.handleClose()
                      this.viewContact()
                    }}
                  >
                    联系方式
                  </div>
                ),
              },
            ]}
            selectable={false}
            style={{ marginTop: 10 }}
          />
        </ConfigProvider>
      </Drawer>
    )
  }

  viewCompanyInfo = () => {
    this.props.history.push('/company')
  }

  viewCertificates = () => {
    this.props.history.push('/certificates')
  }

  viewContact = () => {
    this.props.history.push('/contact')
  }

  downloadFile = (fileUrl) => {
    // const a = document.createElement('a')
    // a.style.display = 'none'
    // a.href = fileUrl
    // a.target = '_blank'
    // a.rel = 'noopener noreferrer'
    // a.download = ''
    // document.body.appendChild(a)
    // a.click()
    // document.body.removeChild(a)
    window.open(fileUrl, '_blank')
  }
}
